<template>
  <div class="mb-3">
    <Alert type="alert-info" text="No chats created. Click Create New Chat" v-if="chat_names.length == 0"></Alert>
    <div class="input-group mb-3" v-for="(chat_name, index) in chat_names" :key="index">
      <div class="input-group-prepend">
        <button @click="editChat(index)" class="btn btn-outline-success btn-sm">edit</button>
      </div>
      <span class="form-control">{{chat_name}}</span>
      <div class="input-group-append">
        <!-- does'nt work -> create complications with bot
          <button @click="copyChat(index)" class="btn btn-outline-info btn-sm">copy</button>-->
        <button @click="removeChat(index)" class="btn btn-outline-danger btn-sm">X</button>
      </div>
    </div>
  </div>
</template>


<script>
import Alert from "@/components/Alert.vue";

export default {
  name:'Chats',
  components:{
    Alert
  },
  props:{
    chat_names: Array,
  },
  methods:{
    editChat: function(index){
      this.$emit('editChat',index);
    },
    removeChat: function(index){
      this.$emit('removeChat',index);
    },
    copyChat: function(index){
      this.$emit('copyChat',index);
    },
  },
}

</script>
